import { IInspectionTenantCategoriesHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

/**
 * The tenant's inspection categories.
 *
 * `enabled` holds the request back until the caller actually needs them: the booking drawer is
 * mounted in the header on every page, and without it every page load asked for categories that
 * only an open drawer shows. Once loaded they are kept until the caller unmounts, so reopening the
 * drawer does not ask again.
 */
export const useInspectionTenantCategories = (enabled = true): IInspectionTenantCategoriesHook => {
  const { inspectionStore } = useStore();
  const { tenantCategories, tenantCategoriesLoading } = inspectionStore;

  useEffect(() => {
    if (!enabled || inspectionStore.tenantCategories.size > 0) return;
    inspectionStore.getAllCategoriesByTenantId(abp.session.tenantId);
  }, [enabled, inspectionStore]);

  useEffect(() => () => inspectionStore.cleartenantCategories(), [inspectionStore]);

  return {
    loading: tenantCategoriesLoading,
    dataSource: Array.from(tenantCategories.values()),
  };
};
